<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <div class="text-right">
        <p-button
          type="info"
          class="mr-2"
          @click="printReport"
        >
          Print
        </p-button>
      </div>
      <card
        v-for="li in listItems"
        :key="li.Id"
      >
        <div class="card-body row table-full-width">
          <el-table
            class="table-striped"
            header-row-class-name="text-danger"
            :data="li.PackingListItems"
          >
            <el-table-column
              prop="Description"
              :label="li.Description"
            />
          </el-table>
        </div>
      </card>
      <packing-list-print
        :list-items="listItems"
        v-show="showPrintItem"
      />
    </div>
  </div>
</template>

<script>
import packingListApi from '@/services/api/packinglist'
import packingListPrint from '@/components/packing-lists/packing-list-print.vue'
import oops from '@/components/_main/oops.vue'

export default {
  name: 'PackingList',
  components: {
    oops,
    packingListPrint
  },
  data: function () {
    return {
      listItems: null,
      loading: true,
      errormessage: null,
      printItem: '',
      showPrintItem: false,
      printOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/packing-list.css'
        ]
      }
    }
  },
  mounted () {
    packingListApi.get(this.$root.courseKey, this.$root.courseScouterType)
      .then(response => {
        this.listItems = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    printReport: function () {
      this.printItem = 'printPackingList'
      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper(this.printItem, this.printOptions)
          // HtmlToPaperTest.show(this.printItem, this.printOptions)
        }
        this.printItem = ''
      })
    }
  }
}
</script>
